import { useGetOne } from 'react-admin'

import PressureGraph from './PressureGraph'
import { VEHICLE_TYPES } from '../config/vehicles'

const PressureGraphs = ({ organisationId }) => {
  const { data } = useGetOne('organisations/pressure', { id: organisationId }, { enabled: Boolean(organisationId) })

  return data
    ? VEHICLE_TYPES.map((code) => (
        <PressureGraph
          key={code}
          title={`resources.vehicles.enums.type.values.${code.toLowerCase()}`}
          data={data[code]}
        />
      ))
    : null
}
export default PressureGraphs
